// Copyright TraderEvolution Global LTD. © 2017-2026. All rights reserved.
import { Resources } from '@shared/localizations/Resources';
import { ReactToRactiveAdapter } from '../ReactToRactiveAdapter';
import { AccountWidget } from '../ReactControls/elements/AccountWidget';
export class AccountWidgetRactive extends ReactToRactiveAdapter {
    constructor() {
        super();
    }
}
ReactToRactiveAdapter.extendWith(AccountWidgetRactive, {
    template: '<div class="accountWidgetSelector"></div>',
    mountContainer: '.accountWidgetSelector',
    reactComponent: AccountWidget,
    data: function () {
        var _a;
        return {
            DragNDropInProcess: false,
            accBtnText: Resources.getResource('accountDetailsWidget.DropdownButton'),
            accBtnTooltip: Resources.getResource('accountDetailsWidget.DropdownButton.Tooltip'),
            AccountHeader: (_a = Resources.getResource('accountDetailsWidget.DropdownButton')) === null || _a === void 0 ? void 0 : _a.toUpperCase(),
            AccountValue: '',
            visible: true,
            focusedAccWidget: false,
            AccountModeStr: 'Demo',
            InsTypeShortName: '',
            InstrumentColor: '',
            accWidgetBtnSelectedClass: '',
            hovered: false
        };
    }
});
